import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  async addContacto({ commit, State }, {admin, condo, propietario, contacto}) {
    const response = await API.post('/contactos/add/' + admin.id + '/' + condo.id + '/' + propietario.id,
      contacto);
    return response.data;
  },
  async deleteContacto({ commit, State }, {admin, condo, propietario, contacto}) {
    const response = await API.delete('/contactos/delete/' + admin.id + '/' + condo.id + '/' + propietario.id +
      '/' + contacto.id);
    return response.data;
  },
  async enableContacto({ commit, State }, {admin, condo, propietario, contacto}) {
    const response = await API.post('/contactos/enabled/' + admin.id + '/' + condo.id + '/' + propietario.id +
      '/' + contacto.id);
    return response.data;
  },
  async disableContacto({ commit, State }, {admin, condo, propietario, contacto}) {
    const response = await API.post('/contactos/disabled/' + admin.id + '/' + condo.id + '/' + propietario.id +
      '/' + contacto.id);
    return response.data;
  },
  async getContactoList({ commit, State }, {admin, condo, propietario}) {
    const response = await API.get('/contactos/list/' + admin.id + '/' + condo.id + '/' + propietario.id);
    return response.data;
  },
  async getContactoEnabledList({ commit, State }, {admin, condo, propietario}) {
    const response = await API.get('/contactos/list/enabled' + admin.id + '/' + condo.id + '/' + propietario.id);
    return response.data;
  },
  async getContactoDisabledList({ commit, State }, {admin, condo, propietario}) {
    const response = await API.get('/contactos/list/disabled' + admin.id + '/' + condo.id + '/' + propietario.id);
    return response.data;
  },
};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
